export default {
  napoleonApi: {
    baseURL: process.env.REACT_APP_NAPOLEON_URL,
  },
};
